import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

export interface ILocationDetail {
  id: number
  code: string
  name: string
}

export interface ILocationDetailsMap {
  [locationId: number]: ILocationDetail
}

const gqlQuery = gql`
  query ListLocationDetails {
    locations {
      nodes {
        id
        code
        name
      }
    }
  }
`

function useListLocationDetails() {
  const { data, loading } = useQuery(gqlQuery)

  return {
    isLoading: loading,
    data: useMemo(() => {
      if (!data?.locations?.nodes) {
        return null
      }

      const locationsMap: ILocationDetailsMap = {}

      data.locations.nodes.forEach((node: any) => {
        locationsMap[node.id] = {
          id: node.id,
          code: node.code,
          name: node.name,
        }
      })

      return locationsMap
    }, [data]),
  }
}

export default useListLocationDetails
